var _rect, _rect2, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgPatientRecordPrescriptionIcon = function SvgPatientRecordPrescriptionIcon(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 0.75,
    width: 26.5,
    height: 26.5,
    rx: 5.25,
    fill: "#F3E9FB"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 0.75,
    width: 26.5,
    height: 26.5,
    rx: 5.25,
    stroke: "#B576E4",
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.6815 11.2151C12.2765 11.62 11.6241 11.6241 11.2241 11.2241C10.8242 10.8242 10.8283 10.1717 11.2332 9.76681C11.6381 9.36188 12.2906 9.35783 12.6905 9.75776C13.0905 10.1577 13.0864 10.8102 12.6815 11.2151ZM12.1987 10.7323C12.0637 10.8673 11.8462 10.8687 11.7129 10.7353C11.5796 10.602 11.581 10.3845 11.716 10.2496C11.8509 10.1146 12.0684 10.1132 12.2017 10.2466C12.335 10.3799 12.3337 10.5974 12.1987 10.7323Z",
    fill: "#8015D0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.4267 8.53879C12.0936 7.20569 9.91874 7.2192 8.56897 8.56896C7.21921 9.91873 7.2057 12.0936 8.5388 13.4267L14.5733 19.4612C15.9064 20.7943 18.0813 20.7808 19.431 19.431C20.7808 18.0813 20.7943 15.9064 19.4612 14.5733L13.4267 8.53879ZM18.728 15.3065L16.1935 12.772L12.772 16.1935L15.3065 18.728C16.2396 19.6612 17.7621 19.6517 18.7069 18.7069C19.6517 17.7621 19.6612 16.2396 18.728 15.3065ZM12.6935 9.27198L15.4694 12.0478L12.0479 15.4694L9.27199 12.6935C8.33882 11.7604 8.34827 10.2379 9.29311 9.2931C10.2379 8.34827 11.7604 8.33881 12.6935 9.27198Z",
    fill: "#8015D0"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgPatientRecordPrescriptionIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "patient-record-prescription-icon.945f0ef8b30f53eee1a5d0a3b18e6dfe.svg";